import React, { useEffect, useState } from 'react';
import {
    GoogleMap,
    withScriptjs,
    withGoogleMap,
    Marker,
    InfoWindow,
} from 'react-google-maps';

const Map = ({ longitude, latitude, name, index, zoom, allCoordinates }) => {
    const validLatitude = Number.isFinite(latitude) ? latitude : 20.5937;
    const validLongitude = Number.isFinite(longitude) ? longitude : 78.9629;

    const [center, setCenter] = useState({ lat: validLatitude, lng: validLongitude });
    const [showInfo, setShowInfo] = useState(false)
    const [showSpecific , setShowSpecific] = useState(false)
    const [address, setAddress] = useState('')
    const [latitudeData, setLatitudeData] = useState(null)
    const [longitudeData, setLongitudeData] = useState(null)

    const handleShowInfo = ( vehicle) => {
        setShowInfo(!showInfo)
        setAddress(vehicle.name)
        setLatitudeData(vehicle.latitude)
        setLongitudeData(vehicle.longitude)
    }

    const handleShowSpecificInfo = (name) => {
        setShowSpecific(!showSpecific)
    }
    useEffect(() => {
        if (Number.isFinite(latitude) && Number.isFinite(longitude)) {
            setCenter({ lat: latitude, lng: longitude });
        }
    }, [latitude, longitude]);

    const handleMapClick = () => {
        setShowInfo(false);
        setShowSpecific(false);  
    };

    return (
        <GoogleMap
            defaultZoom={zoom}
            center={center}
            onClick={handleMapClick} 
        >
            {
                showInfo && longitudeData && latitudeData && (
                    <>
                    <InfoWindow position={{ lat: latitudeData, lng: longitudeData }}>
                        <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
                            <div>
                                <span style={{ color: 'green' }}>Address: </span> {address}
                            </div>
                        </div>
                    </InfoWindow>
                    </>
                )
            }
            {allCoordinates && allCoordinates.length > 0 ? (
                allCoordinates.map((vehicle, i) => (
                    <Marker
                        key={i}
                        position={{ lat: vehicle.latitude, lng: vehicle.longitude }}
                        onClick={() => {
                            handleShowInfo(vehicle)
                        }}
                    />
                ))
            ) : (
                <>
                <Marker
                    key={index}
                    position={{ lat: validLatitude, lng: validLongitude }}
                    // title={name}
                    // label={name}
                    onClick={() => {
                        handleShowSpecificInfo(name)
                    }}
                />
                {
                    showSpecific &&
                    <InfoWindow position={{ lat: validLatitude, lng: validLongitude }}>
                    <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
                        <div>
                            <span style={{ color: 'green' }}>Address: </span> {name}
                        </div>
                    </div>
                </InfoWindow>
                }
                </>
            )}
        </GoogleMap>
    );
};

export default withScriptjs(withGoogleMap(Map));
